// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSAvatarName/index.less
// module id = 700
// module chunks = 42